import styled from "styled-components";

export const ProfileNameWrapper = styled.div`
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 700;
    gap: 8px;
`;
